<template>
  <div>
    <div class="tittle">主体{{title}}</div>
    <div class="content">
      <el-form :model="subjectAdd" :inline="true" :rules="dataRules" ref="subjectAdd" class="ml20 mr20" label-position="right" label-width="270px">
        <toggle-form title="平台信息">
          <div class="item">
            <el-form-item label="TOBID：">
              <div class="w300">
                <span>{{tobBind}}</span>
                <el-button class="ml20" @click="bindTob" type="primary">绑定</el-button>
              </div>
            </el-form-item>
            <div></div>
            <el-form-item label="TOBID：" prop="tobId">
              <div class="w300">{{subjectAdd.tobId ? subjectAdd.tobId : '-'}}</div>
            </el-form-item>
            <el-form-item label="理菜宝名称：" prop="tobName" >
              <div class="w300">{{subjectAdd.tobName ? subjectAdd.tobName : '-'}}</div>
            </el-form-item>
            <el-form-item label="TOGID：">
              <div class="w300">
                <span>{{togBind}}</span>
                <el-button class="ml20" @click="bindTog" type="primary">绑定</el-button>
              </div>
            </el-form-item>
            <div></div>
            <el-form-item label="TOGID：" prop="togId">
              <div class="w300">{{subjectAdd.togId ? subjectAdd.togId : '-'}}</div>
            </el-form-item>
            <el-form-item label="TOG环境名称：" prop="togSystemName">
              <div class="w300">{{subjectAdd.togSystemName ? subjectAdd.togSystemName : '-'}}</div>
            </el-form-item>
            <el-form-item label="TOG名称：" prop="togName">
              <div class="w300">{{subjectAdd.togName ? subjectAdd.togName : '-'}}</div>
            </el-form-item>
            <div></div>
            <!-- <el-form-item label="第三方平台类型：" prop="">
              <el-select class="w300" v-model="platformType" @change="platformTypeChange" clearable placeholder="空">
                <el-option v-for="item in platformTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="第三方平台ID：" prop="">
              <el-input class="w300" placeholder="请输入第三方平台ID, 50字以内" maxlength="50" clearable v-model="platformID"></el-input>
            </el-form-item> -->
            <el-form-item v-if="$route.query.type === 'add'" label="摄像头初始化：" prop="cameraInit">
              <el-select class="w300" v-model="subjectAdd.cameraInit" @change="cameraInitChange" placeholder="是否初始化摄像头配置">
                <el-option v-for="item in cameraInitTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </toggle-form>
        <toggle-form title="基本信息">
          <div class="item">
            <el-form-item label="主体名称：" prop="buyerName">
              <el-input class="w300" placeholder="请输入主体名称, 50字以内" maxlength="50" clearable v-model="subjectAdd.buyerName"></el-input>
            </el-form-item>
            <el-form-item label="所属行政区域：" prop="areaId">
              <el-cascader class="w300" v-model="subjectAdd.areaId" :options="areaList.options" @change="areaChange" :props="areaList.props" clearable placeholder="所属行政区" ref="cascader"></el-cascader>
             <!-- <el-tooltip v-if="$route.query.type !== 'add'" class="item" effect="dark" content="如需修改行政区域请联系相关技术人员" placement="left-start">
                <i class="el-icon-question tooltip"></i>
              </el-tooltip>-->
            </el-form-item>
            <el-form-item label="启用禁用：" prop="available">
              <el-select class="w300" v-model="subjectAdd.available" @change="enableModeChange" clearable placeholder="请选择是否启用">
                <el-option v-for="item in enableModeTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="街道名称：" prop="streetAreaName">
              <el-input class="w300"  maxlength="50" v-model="subjectAdd.streetAreaName" disabled></el-input>
            </el-form-item>
            <el-form-item label="同步TOB管理员账号及密码：" prop="isSyncTobAdminAccount">
              <el-select class="w300" v-model="subjectAdd.isSyncTobAdminAccount" @change="syncChange" clearable placeholder="请选择是否同步">
                <el-option v-for="item in syncTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="管理员姓名：" prop="adminName">
              <el-input class="w300" placeholder="请输入TOB管理员姓名, 30字以内" maxlength="30" clearable v-model="subjectAdd.adminName"></el-input>
            </el-form-item>
            <el-form-item label="管理员账号：" prop="adminAccount">
              <el-input class="w300" placeholder="请输入TOB管理员账号, 30字以内" maxlength="30" clearable v-model="subjectAdd.adminAccount" @input="change($event)"></el-input>
            </el-form-item>
            <el-form-item label="管理员密码：" prop="adminPassword">
              <el-input v-if="$route.query.type === 'add'" class="w300" type="password" placeholder="请输入TOB管理员密码, 6-15字以内" maxlength="15" clearable v-model="subjectAdd.adminPassword" @input="change($event)"></el-input>
              <el-button v-else @click="updatePwd" type="primary">修改密码</el-button>
            </el-form-item>
            <el-form-item label="采集模式：" prop="acquisitionMode">
              <el-select class="w300" v-model="subjectAdd.acquisitionMode" @change="gatherModeChange" clearable placeholder="请选择采集模式">
                <el-option v-for="item in gatherModeTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="溯源模式：" prop="traceabilityMode">
              <el-select class="w300" v-model="subjectAdd.traceabilityMode" @change="traceModeChange" clearable placeholder="请选择溯源模式">
                <el-option v-for="item in traceModeTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="量化等级：" prop="qualityLevel">
              <el-input class="w300" placeholder="请输入量化等级, 10字以内" maxlength="10" clearable v-model="subjectAdd.qualityLevel"></el-input>
            </el-form-item>
            <el-form-item label="风险分级：" prop="riskLevel">
              <el-input class="w300" placeholder="请输入风险分级, 10字以内" maxlength="10" clearable v-model="subjectAdd.riskLevel"></el-input>
            </el-form-item>
            <el-form-item label="法人(负责人)：" prop="legalPerson">
              <el-input class="w300" placeholder="请输入法人负责人, 30字以内" maxlength="30" clearable v-model="subjectAdd.legalPerson"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="tel">
              <el-input class="w300" placeholder="请输入联系电话, 30字以内" maxlength="30" clearable v-model="subjectAdd.tel"></el-input>
            </el-form-item>
            <el-form-item label="联系地址：" prop="address">
              <el-input class="w300" placeholder="请输入联系地址, 100字以内" maxlength="100" clearable v-model="subjectAdd.address"></el-input>
            </el-form-item>
             <el-form-item  label="功能集：" prop="collectionId">
              <el-select class="w300" v-model="subjectAdd.collectionId"  placeholder="请选择功能集角色">
                <el-option v-for="item in functionModule" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item  label="是否纳入餐饮示范街：" prop="demoStreet">
              <el-select :disabled="!isScTypeDisabled" class="w300" v-model="subjectAdd.demoStreet" placeholder="请选择是否是餐饮示范街">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </toggle-form>
        <toggle-form title="经营信息">
          <div class="item">
             <el-form-item label="经营面积：">
              <el-input class="w300" placeholder="例：120" maxlength="30" clearable v-model="subjectAdd.cover"><i slot="suffix" style="font-style:normal" class="metre">㎡</i></el-input>
            </el-form-item>
             <el-form-item label="经营场所：" prop="workspace">
              <el-input class="w300" placeholder="请输入经营场所（100字以内）" maxlength="100" clearable v-model="subjectAdd.workspace"></el-input>
            </el-form-item>
            <el-form-item label="GPS地址：" prop="gpsAddress">
              <el-input class="w750" placeholder="请输入实际地址, 将使用该地址解析经纬度, 100字以内" maxlength="100" @keyup.enter.native="getCoordinate" clearable v-model="subjectAdd.gpsAddress"></el-input>
              <el-button class="ml20" @click="getCoordinate" type="primary">获取经纬度</el-button>
            </el-form-item>
            <div class="manage-info-flex">
               <el-form-item label="经度：" prop="lng">
              <el-input class="w200" placeholder="请输入经度, -180~180之间, 保留6位小数" maxlength="11" clearable v-model="subjectAdd.lng"></el-input>
            </el-form-item>
            <el-form-item label="纬度：" prop="lat">
              <el-input class="w200" placeholder="请输入纬度, -90~90之间, 保留6位小数" maxlength="10" clearable v-model="subjectAdd.lat"></el-input>
            </el-form-item>
            </div>
           <div class="manage-info-flex">
              <el-form-item label="行业类型：" prop="buyerType">
              <el-select class="w200" v-model="subjectAdd.buyerType" @change="subTypeChange" clearable placeholder="请选择行业类型">
                <el-option v-for="item in subTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学校类型：">
              <el-select class="w200" :disabled="isScTypeDisabled" v-model="subjectAdd.scType" @change="schoolTypeChange" clearable placeholder="请选择学校类型">
                <el-option v-for="item in schoolTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
           </div>
            <div class="manage-info-flex">
            <el-form-item label="营业状态：">
              <el-select class="w200" v-model="subjectAdd.workStatus" clearable placeholder="请选择营业状态">
                <el-option v-for="item in workStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="从业人数：">
              <el-input class="w200" placeholder="例：20" maxlength="30" clearable v-model="subjectAdd.empNumber"></el-input>
            </el-form-item>
           </div>
           <div class="manage-info-flex">
            <el-form-item label="主体业态：">
              <el-select class="w200" v-model="subjectAdd.entityType" clearable placeholder="请选择主体业态">
                <el-option v-for="item in entityType" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="是否提供网络外卖服务：">
              <el-select class="w200" v-model="subjectAdd.takeOut" clearable placeholder="是否提供网络外卖服务">
                <el-option v-for="item in takeOutList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
           </div>
             <el-form-item label="网络经营：">
              <el-select class="w200" v-model="subjectAdd.onlineType" clearable placeholder="请选择网络经营类型">
                <el-option v-for="item in onlineType" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </toggle-form>
        <toggle-form title="证照信息">
          <div class="item">
            <el-form-item label="食品经营许可证编号：" prop="licence">
              <el-input class="w300" placeholder="请输入食品经营许可证编号, 30字以内" maxlength="30" clearable v-model="subjectAdd.licence"></el-input>
            </el-form-item>
            <el-form-item label="食品经营许可证有效期：" prop="licenceExpdate">
              <el-date-picker class="w300" v-model="subjectAdd.licenceExpdate" type="date" placeholder="请选择食品经营许可证有效期" clearable @change="dateChange" :picker-options="beforeDate" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="食品经营许可证图片：" prop="licenceImgUrl">
              <div class="w500">
                <upload-img @getImgUrl="getLicenceImgUrl" :echoImgUrl="subjectAdd.licenceImgUrl"></upload-img>
              </div>
            </el-form-item>
            <el-form-item label="营业执照编号：" prop="creditCode">
              <el-input class="w300" placeholder="请输入营业执照编号, 30字以内" maxlength="30" clearable v-model="subjectAdd.creditCode"></el-input>
            </el-form-item>
            <el-form-item label="营业执照图片：" prop="creditImgUrl">
              <div class="w500">
                <upload-img @getImgUrl="getCreditImgUrl" :echoImgUrl="subjectAdd.creditImgUrl"></upload-img>
              </div>
            </el-form-item>
          </div>
        </toggle-form>
      </el-form>
    </div>
    <div class="footer">
        <el-button @click="cancle" round>返回</el-button>
        <el-button type="primary" @click="submit('subjectAdd')" round>保存</el-button>
    </div>

    <tog-sub-dialog v-if="togSubDialogVisible" :togSubData="togSubData" @getTogData="getTogData" @isTogSync="isTogSync" :tog-sub-dialog-visible="togSubDialogVisible" @closeTogSubDialog="closeTogSubDialogVisible"></tog-sub-dialog>

    <tob-sub-dialog v-if="tobSubDialogVisible" :hasAdmin="hasAdmin" @tobSubData="getTobData"  @isTobSync="isTobSync" @isAdminSync="isAdminSync" :tob-sub-dialog-visible="tobSubDialogVisible" @closeTobSubDialog="closeTobSubDialogVisible"></tob-sub-dialog>

    <el-dialog v-if="pwdDialogVisible" :visible.sync="pwdDialogVisible" :close-on-click-modal="false" title="修改密码" style="padding-top: 0px;">
        <el-form :model="pwdData" :rules="pwdDataRules" ref="pwdData" class="ml20 mr20" label-position="right" label-width="150px">
            <div class="item">
                <el-form-item label="新密码：" prop="newPwd">
                    <el-input class="w300" type="password" placeholder="请输入新密码, 6-15字以内" maxlength="15" clearable v-model="pwdData.newPwd" @input="pwChange($event)"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码：" prop="confirmPwd">
                    <el-input class="w300" type="password" placeholder="请再次输入新密码, 6-15字以内" maxlength="15" clearable v-model="pwdData.confirmPwd" @input="pwChange($event)"></el-input>
                </el-form-item>
            </div>
        </el-form>
        <div class="footer">
            <el-button @click="canclePwd" round>关闭</el-button>
            <el-button type="primary" @click="submitPwd('pwdData')" round>保存</el-button>
        </div>
    </el-dialog>

    <el-dialog class="dialogDiv" v-if="mapDialogVisible" :visible.sync="mapDialogVisible" :close-on-click-modal="false" title="获取经纬度" style="padding-top: 0px;">
        <el-form :model="mapData" :rules="mapDataRules" :inline="true" ref="mapData" label-position="right">
            <div class="form-item">
                <el-form-item label="地址：" prop="gpsAddress">
                    <!-- <el-input class="w500" placeholder="" maxlength="20" clearable v-model="mapData.gpsAddress"></el-input> -->
                    <span>{{mapData.gpsAddress}}</span>
                </el-form-item>
                <el-form-item label="经度：" class="ml20" prop="lng">
                    <span>{{mapData.lng}}</span>
                    <!-- <el-input class="w300" placeholder="请输入新密码, 20字以内" maxlength="20" clearable v-model="mapData.lng"></el-input> -->
                </el-form-item>
                <el-form-item label="纬度：" class="ml20" prop="lat">
                    <span>{{mapData.lat}}</span>
                    <!-- <el-input class="w300" placeholder="请输入新密码, 20字以内" maxlength="20" clearable v-model="mapData.lat"></el-input> -->
                </el-form-item>
            </div>
            <div id="container"></div>
        </el-form>
        <div class="footer">
            <el-button @click="cancleMap" round>关闭</el-button>
            <el-button type="primary" @click="submitMap('pwdData')" round>保存</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import ToggleForm from "components/ToggleForm"
import UploadImg from "components/UploadImg"
import TogSubDialog from './TogSubDialog'
import TobSubDialog from './TobSubDialog'
import * as mapping from '@/utils/enumList'
import * as subManageApi from '@/api/subManage';
import * as moduleApi from '@/api/module';

var geocoder;
var marker;
var map;
export default {
  components: {
    ToggleForm,
    // ImgUpload,
    UploadImg,
    TogSubDialog,
    TobSubDialog
  },
  data() {
    return {
      validFlag:true,
      validPwFlag:true,
      title: '添加',
      parentId: '0',
      areaList: {
        selOptions: [],
        options: [],
        parentCode: '',
        props: {
          checkStrictly: true,
          // expandTrigger: 'hover',
          value: 'areaId',
          label: 'areaName',
          children: 'children',
          lazy: true,
          lazyLoad(node, resolve) {}
        }
      },
      functionModule:[],
      subjectAdd: {
        tobId: '',
        tobName: '',
        togId: null,
        togName: '',
        togSystemName: '',
        cameraInit: '',
        buyerName: '',
        areaId: '',
        streetAreaName:'',
        isSyncTobAdminAccount: '0',
        adminName: '',
        adminId: '',
        adminAccount: '',
        adminPassword: '',
        acquisitionMode: '1',
        traceabilityMode: '2',
        available: '1',
        buyerType: '',
        scType: '',
        qualityLevel: '',
        gpsAddress: '',
        lng: '',
        lat: '',
        legalPerson: '',
        tel: '',
        address: '',
        collectionId:'',
        demoStreet: 0,

        licence: '',
        licenceExpdate: '',
        licenceImgUrl: '',
        creditCode: '',
        creditImgUrl: '',

        deptCode: '',
        togLicense: '',
        togCreditCode: '',
        togEntityType: '',
        togAreaCode: ''
      },
      dataRules: {
        buyerName: [{ required: true, message: '请输入主体名称, 50字以内', trigger: 'blur' }], 
        areaId: [{ required: true, message: '请选择所属行政区', trigger: 'change' }], 
        isSyncTobAdminAccount: [{ required: true,  message: '请选择是否同步管理员账号信息', trigger: 'change' }], 
        adminName: [{ required: true, message: '请输入TOB管理员姓名, 30字以内', trigger: 'blur' }], 
        adminAccount: [{ required: true, message: '请输入TOB管理员账号, 30字以内, 不能含空格', trigger: 'change' }], 
        adminPassword: [{ required: true, message: '请输入TOB管理员密码, 6-15字以内, 不能含空格', min: 6, trigger: 'change' }],
        acquisitionMode: [{ required: true, message: '请选择采集模式', trigger: 'change' }], 
        traceabilityMode: [{ required: true, message: '请选择溯源模式', trigger: 'change' }], 
        available: [{ required: true, message: '请选择启用禁用', trigger: 'change' }],
        workspace: [{ required: true, message: '请输入经营场所, 100字以内', trigger: 'blur' }],
        buyerType: [{ required: true, message: '请选择行业类型', trigger: 'change' }], 
        collectionId:[{ required: true, message: '请配置功能集角色', trigger: 'change' }],
        demoStreet:[{ required: true, message: '请选择是否纳入餐饮示范街', trigger: 'change' }],
        gpsAddress: [{ required: true, message: '请输入实际地址, 将使用该地址解析经纬度, 100字以内', trigger: 'blur' }],
        lng: [{ required: true, pattern: /^[\-\+]?(0(\.\d{6})?|([1-9](\d)?)(\.\d{6})?|1[0-7]\d{1}(\.\d{6})?|180\.0{1,10})$/, message: '请输入经度, -180~180之间, 保留6位小数', trigger: 'change' }], 
        lat: [{ required: true, pattern:  /^[\-\+]?((0|([1-8]\d?))(\.\d{6})?|90(\.0{6})?)$/, message: '请输入纬度, -90~90之间, 保留6位小数', trigger: 'change' }],
        tel: [{ pattern: /^((1[3456789]\d{9})|(0\d{2,3}-\d{7,8}))$/, message: '请输入手机或固话, 固话格式为"区号-号码"', trigger: 'blur' }]
      },
      // platformType: '',
      // platformTypes: [{
      //   label: '望家欢',
      //   value: 'WJH'
      // }],
      // platformID: '',
      cameraInitTypes: mapping.getKeyVal('cameraInit'),
      syncTypes: mapping.getKeyVal('isSyncTobAdminAccount'),
      gatherModeTypes: mapping.getKeyVal('acquisitionMode'),
      traceModeTypes:mapping.getKeyVal('traceabilityMode'),
      enableModeTypes: mapping.getKeyVal('available'),
      subTypes: mapping.getKeyVal('buyerType'),
      schoolTypes: mapping.getKeyVal('scType'),
      workStatus: [
        {value:1,label:'正常营业'},
        {value:2,label:'暂停营业'},
        {value:3,label:'停止营业'},
      ],
      onlineType:[
        {value:1,label:'美团'},
        {value:2,label:'饿了么'},
      ],
      takeOutList:[
        {value:1,label:'是'},
        {value:2,label:'否'},
      ],
      entityType:[
        {value:1,label:'小吃店'},
        {value:2,label:'快餐店'},
        {value:3,label:'小型餐饮'},
        {value:4,label:'中型餐饮'},
        {value:5,label:'大型餐饮'},
        {value:6,label:'特大型餐饮'},
        {value:7,label:'饮品店（含甜品站）'},
        {value:8,label:'集体用餐配送单位'},
        {value:9,label:'中央厨房'},
        {value:10,label:'学校（含托幼机构）食堂'},
        {value:11,label:'机关企事业单位食堂'},
        {value:12,label:'工地食堂'},
        {value:13,label:'其他食堂'},
      ],
      // onlineType: mapping.getKeyVal('onlineType'),
      // takeOutList: mapping.getKeyVal('takeOutList'),
      // entityType: mapping.getKeyVal('entityType'),
      startDate: '',
      beforeDate: {
        // disabledDate: (time) => {
        //   let before = new Date("2018-01-01") - 8.64e7;
        //   let after = new Date();
        //   let endDate = new Date(this.endDate)
        //   if (this.endDate) {
        //       return time.getTime() > endDate || time.getTime() > after || time.getTime() < before;
        //   } else {
        //       return time.getTime() > after || time.getTime() < before;
        //   }
        // }
      },
      echoFileId: '',
      getImgFile: '',
      togSubData: {},
      togData: {},
      togSubDialogVisible: false,
      tobData: {},
      tobSubDialogVisible: false,
      hasAdmin: false,
      pwdDialogVisible: false,
      mapDialogVisible: false,
      pwdData: {
        newPwd: '',
        confirmPwd: ''
      },
      pwdDataRules: {
        newPwd: [
          { required: true, message: '请输入新密码, 6-15字以内', min: 6, trigger: 'blur' }
        ],
        confirmPwd: [
          { required: true, message: '请再次输入新密码, 6-15字以内', min: 6, trigger: 'blur' }
        ]
      },
      mapData: {
        gpsAddress: '',
        lng: '',
        lat: ''
      },
      mapDataRules: {

      },
      areaData: []
    }
  },
  computed: {
    isAreaDisabled: function() {
      return this.$route.query.type !== 'add' ? true : false
    },
    isScTypeDisabled: function() {
      return ['KINDSC', 'PRISC', 'MIDSC', 'HIGSC', 'UNVSC', ''].indexOf(this.subjectAdd.buyerType) === -1 ? true : false
    },
    tobBind: function() {
      return this.subjectAdd.tobId ? '已绑定' : '未绑定'
    },
    togBind: function() {
      return this.subjectAdd.togId  ? '已绑定' : '未绑定'
    },
    queryParams: function() {
      return this.subjectAdd
    }
  },
  methods: {
    // 从第三方平台接口添加的主体，不允许绑定TOBID。目前只限定在编辑页面。
    bindTob() {
      this.tobSubDialogVisible = true
      // 绑定tobId前已经编辑了管理员账号和密码(手动编辑, 而非同步)
      if(this.subjectAdd.adminAccount && this.subjectAdd.adminPassword) {
        this.hasAdmin = true
      }
      // 绑定tobId前已经编辑了管理员账号和密码(手动编辑和从tob同步的账号和密码)
      // if(this.subjectAdd.adminAccount && this.subjectAdd.adminPassword) {
      //   this.hasAdmin = true
      // }
    },
    bindTog() {
      // 根据 tobId和tobAreaId 请求对应的tog数据
      this.togSubDialogVisible = true
    },
    // 关闭tog弹窗
    closeTogSubDialogVisible() {
      this.togSubDialogVisible = false
    },
    // 获取tog环境名称
    getTogSystemName() {
      subManageApi.togSysList().then(res => {
        if(res.code === 200) {
          res.data.forEach(item => {
            if(this.subjectAdd.togSystemName === item.appId) {
              this.subjectAdd.togSystemName = item.title
            }
          })
        }
      }).catch(err => {})
    },
    getTogData(togData) {
      this.togData = togData

      this.subjectAdd.togId = this.togData.id
      this.subjectAdd.togName = this.togData.entityName
      this.subjectAdd.togSystemName = this.togData.togSystemName
      this.subjectAdd.togAreaCode = this.togData.togAreaCode
      this.getTogSystemName() // 转换tog环境名称为中文
    },
    // 是否同步tog字段
    isTogSync(val) {
      // 不同步
      this.subjectAdd.togAreaCode = this.togData.togAreaCode
      if(!val) return
      // 同步
      this.subjectAdd.buyerName = this.togData.entityName
      this.subjectAdd.areaId = this.togData.regionCode
      this.subjectAdd.qualityLevel = this.togData.quanLevel
      this.subjectAdd.gpsAddress = this.togData.realityAddress
      this.subjectAdd.lng = this.togData.lng ? parseFloat(this.togData.lng).toFixed(6) : ''
      this.subjectAdd.lat = this.togData.lat ? parseFloat(this.togData.lat).toFixed(6) : ''
      this.subjectAdd.legalPerson = this.togData.corpName
      this.subjectAdd.tel = this.togData.mobile
      this.subjectAdd.address = this.togData.registerAddress
      
      if(this.togData.creditCode) {
        this.subjectAdd.creditCode = this.togData.creditCode
      }
      if(this.togData.licence) {
        this.subjectAdd.licence = this.togData.licence
      }
      if(this.togData.licEnd) {
        this.subjectAdd.licenceExpdate = this.togData.licEnd
      }
      
      this.subjectAdd.togEntityType = this.togData.entityType
      this.subjectAdd.togCreditCode = this.togData.creditCode
      this.subjectAdd.togLicense = this.togData.licence
    },
    // 关闭tob弹窗
    closeTobSubDialogVisible() {
      this.tobSubDialogVisible = false
    },
    // 要绑定的tob数据
    getTobData(data) {
      this.tobData = data
      this.subjectAdd.tobId = this.tobData.id
      this.subjectAdd.tobName = this.tobData.buyerName
    },
    // 是否同步tob字段
    isTobSync(val) {
      // 从tob绑定时，从TOB同步管理员账号默认为'是', 且可改为'否'
      this.subjectAdd.isSyncTobAdminAccount = '1'
      // 不同步tob字段
      if(!val) return
      // 同步tob字段
      this.subjectAdd.buyerName = this.subjectAdd.tobName
      this.subjectAdd.areaId = this.tobData.areaId
      this.subjectAdd.isSyncTobAdminAccount = '1'
      this.subjectAdd.adminName = this.tobData.realName
      this.subjectAdd.buyerType = mapping.valToKey('buyerType', this.tobData.buyerType)
      this.subjectAdd.scType = this.tobData.scType
      this.subjectAdd.gpsAddress = this.tobData.gpsAddress
      this.subjectAdd.lng = this.tobData.lng ? parseFloat(this.tobData.lng).toFixed(6) : ''
      this.subjectAdd.lat = this.tobData.lat ? parseFloat(this.tobData.lat).toFixed(6) : ''
      this.subjectAdd.legalPerson = this.tobData.legalPerson
      this.subjectAdd.tel = this.tobData.tel
      this.subjectAdd.address = this.tobData.address

      if(this.tobData.creditCode) {
        this.subjectAdd.creditCode = this.tobData.creditCode
      }
      if(this.tobData.ossBsLicImg) {
        this.subjectAdd.creditImgUrl = this.tobData.ossBsLicImg
      }
      if(this.tobData.ossFoodLicense) {
        this.subjectAdd.licence = ''
        this.subjectAdd.licenceExpdate = ''
        this.subjectAdd.licenceImgUrl = this.tobData.ossFoodLicense
      }

      this.subjectAdd.deptCode = this.tobData.deptCode
      if(!this.hasAdmin) { // 同步之前没有编辑管理员账号和密码时, 直接从Tob拉取管理员账号和密码
        this.subjectAdd.adminAccount = this.tobData.userName
        this.subjectAdd.adminPassword = this.tobData.password
      }
    },
    // 是否同步管理员账号和密码
    isAdminSync(val) {
      if(!val) return
      // 同步之前已经编辑了管理员账号和密码, 且弹框时确认要同步账号和密码(覆盖之前的手动输入)
      this.subjectAdd.adminAccount = this.tobData.userName
      this.subjectAdd.adminPassword = this.tobData.password
    },
    // platformTypeChange() {
      
    // },
    cameraInitChange() {

    },
    areaChange(value) {
      this.areaList.selOptions = value
      this.subjectAdd.areaId = value[value.length - 1]
      if (value.length == 4){
        this.subjectAdd.streetAreaName = this.$refs['cascader'].getCheckedNodes()[0].label
      }else{
        this.subjectAdd.streetAreaName = ''
      }
    },
    // 是否同步TOB管理员账号和密码
    syncChange(val) {

    },
    change(e){
      this.$forceUpdate()
      console.log(e);
       if(/\s+/g.test(e)){
         this.validFlag = false
        this.$message.warning('管理员账号及密码不可包含空格')
      }
    },
    pwChange(e){
      this.$forceUpdate()
      console.log(e);
       if(/\s+/g.test(e)){
         this.validPwFlag = false
        this.$message.warning('密码不可包含空格')
      }
    },
    gatherModeChange(val) {

    },
    traceModeChange(val) {
      
    },
    enableModeChange(val) {

    },
    subTypeChange(val) {
      // if(this.subjectAdd.scType) {
        if(['KINDSC', 'PRISC', 'MIDSC', 'HIGSC', 'UNVSC', ''].indexOf(val) === -1) {
          this.subjectAdd.scType = ''
        }else{
          this.subjectAdd.demoStreet = 0;
        }
      // }
    },
    schoolTypeChange(val) {

    },
    dateChange(val) {

    },
    getLicenceImgUrl(url) {
      this.subjectAdd.licenceImgUrl = url
    },
    getCreditImgUrl(url) {
      this.subjectAdd.creditImgUrl = url
    },
    // 地图弹框
    getCoordinate() {
      if(!this.subjectAdd.gpsAddress) {
        this.$message.warning('GPS地址为空，无法获取')
        return
      }
      this.mapDialogVisible = true
      this.locate()
      this.mapShowFun()
    },
    cancleMap() {
      this.mapDialogVisible = false
    },
    submitMap(mapData) {
      // TODO 经纬度格式校验
      this.subjectAdd.gpsAddress = this.mapData.gpsAddress
      this.subjectAdd.lng = this.mapData.lng
      this.subjectAdd.lat = this.mapData.lat
      this.mapDialogVisible = false
    },
    locate() {
      let that = this;
      AMap.plugin('AMap.Geocoder', function() {
          geocoder = new AMap.Geocoder()
          geocoder.getLocation(that.subjectAdd.gpsAddress, function(status, result) {
              if (status === 'complete' && result.info === 'OK') {
                  // result中对应详细地理坐标信息
                  let lng = result.geocodes[0].location.lng;
                  let lat = result.geocodes[0].location.lat;
                  that.mapData.gpsAddress = result.geocodes[0].formattedAddress;
                  that.mapData.lng = parseFloat(lng).toFixed(6)
                  that.mapData.lat = parseFloat(lat).toFixed(6)

                  map.setZoomAndCenter(15, [result.geocodes[0].location.lng, result.geocodes[0].location.lat]);
                  that.addMarker(result.geocodes[0].location.lng, result.geocodes[0].location.lat);
              } else {
                  that.mapData.gpsAddress = '四川省成都市'
                  that.mapData.lng = 104.066541
                  that.mapData.lat = 30.572269
                  that.$message.warning('GPS地址无法解析! 请输入正确的地址或点击地图获取')
              }
          })
      })
    },
    mapShowFun() {
      setTimeout(() => {
          map = new AMap.Map('container', {
              resizeEnable: true, //是否监控地图容器尺寸变化
          });
          let that = this;
          AMap.event.addListener(map, 'click', function (e) { //添加点击事件,传入对象名，事件名，回调函数
              if(marker) {
                  map.remove(marker);
              }
              AMap.plugin('AMap.Geocoder', function() {
                  geocoder = new AMap.Geocoder({})
                  var lnglat = [e.lnglat.getLng(), e.lnglat.getLat()]
                  geocoder.getAddress(lnglat, function(status, result) {
                      if (status === 'complete' && result.info === 'OK') {
                        map.setCenter(e.lnglat);
                        // result为对应的地理位置详细信息
                        let lng = e.lnglat.getLng();
                        let lat = e.lnglat.getLat();
                        that.mapData.gpsAddress = result.regeocode.formattedAddress;
                        that.mapData.lng = parseFloat(lng).toFixed(6);
                        that.mapData.lat = parseFloat(lat).toFixed(6);
                      }
                  })
              })
              that.addMarker(e.lnglat.getLng(), e.lnglat.getLat());
              map.setFitView();
          })
      }, 100)
    },
    addMarker(lng, lat) {
      let icon = new AMap.Icon({
          size: new AMap.Size(30, 40),    // 图标尺寸
          image: 'http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',  // Icon的图像
          imageOffset: new AMap.Pixel(0, 0),  // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(30, 40)   // 根据所设置的大小拉伸或压缩图片
      });
      marker = new AMap.Marker({
          icon: icon,
          position: [lng, lat],
          offset: new AMap.Pixel(-10, -40)
      });
      marker.setMap(map);
      marker.setAnimation('AMAP_ANIMATION_DROP');
    },


    // 修改密码弹框
    updatePwd() {
      this.pwdDialogVisible = true
    },
    canclePwd() {
      this.pwdDialogVisible = false
    },
    submitPwd(pwdData) {
      if(this.validPwFlag){
        this.$refs.pwdData.validate((valid) => {
        if (valid) {
          if(this.pwdData.newPwd !== this.pwdData.confirmPwd) {
            this.$message.warning('两次输入的密码不一致, 请检查并重新输入')
            return
          } else { // 修改密码
            let pwdParams = {
              adminId: this.subjectAdd.adminId,
              checkPassword: this.pwdData.confirmPwd,
              password: this.pwdData.newPwd
            }
            subManageApi.pwdUpdate(pwdParams).then(res => {
              if(res.code === 200) {
                this.$message.success('密码修改成功')
                this.pwdDialogVisible = false
                this.subjectAdd.adminPassword = this.pwdData.confirmPwd
              }
            }).catch(err => {})
          }
        }
      })
      }else{
        this.$message.warning('密码不能包含空格,请重新输入!')
        this.pwdData.newPwd = ''
        this.pwdData.confirmPwd = ''
        this.validPwFlag = true
      }
    },
    cancle() {
      this.$router.go(-1)
    },
    submit(subjectAdd) {
      if(this.validFlag){
        this.$refs[subjectAdd].validate((valid) => {
        if (valid) {
          let areaIdStr = ''
          if(Object.prototype.toString.call(this.subjectAdd.areaId) === '[object Array]') { // 判断为数组
            areaIdStr = this.subjectAdd.areaId[this.subjectAdd.areaId.length-1]
          } else {
            areaIdStr = this.subjectAdd.areaId
          }
          this.subjectAdd.areaId = areaIdStr
          
          if(this.$route.query.type !== 'add') { // 编辑
            this.subjectAdd.guid = this.$route.query.id
            this.subjectAddSubmit()
          } else { // 添加
            if(areaIdStr.substring(areaIdStr.length-2, areaIdStr.length) === '00' ) {
              this.$message.warning('所属行政区域需选择到区一级')
              return
            }
            subManageApi.isAdminExist({account: this.subjectAdd.adminAccount}).then(res => {
              if(res.code === 200) {
                if(res.data === true) {
                  this.$message.warning('管理员账号已存在, 请修改后再添加')
                } else {
                  this.subjectAddSubmit()
                }
              }
            }).catch(err => {})
          }
        }
      })
      }else{
        this.$message.warning('管理员账号或密码包含空格,请重新输入!')
        this.subjectAdd.adminAccount = ''
        this.subjectAdd.adminPassword = ''
        this.validFlag = true
      }
    },
    subjectAddSubmit() {
      let promise = this.$route.query.type === 'add' ?
                    subManageApi.subjectAdd(this.subjectAdd) : 
                    subManageApi.subjectUpdate(this.subjectAdd)
      promise.then(res => {
        if(res.code === 200) {
          this.$message.success(this.$route.query.type === 'add' ? '添加成功' : '编辑成功')
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000);
        }
      }).catch(err => {})
    },
    addInit() {
      this.title = '添加'
      this.formAdd = {}
    },
    editInit(id) {
      this.title = '编辑'
      subManageApi.subjectDetail({id: id}).then(res => {
        if(res.code === 200) {
          if(res.data.workStatus==0){
            res.data.workStatus = ''
          }
          if(res.data.onlineType==0){
            res.data.onlineType = ''
          }
          if(res.data.entityType==0){
            res.data.entityType = ''
          }
          if(res.data.takeOut==0){
            res.data.takeOut = ''
          }
          // 详情数据回显
          this.subjectAdd = res.data
          this.subjectAdd.lat = res.data.lat ? parseFloat(res.data.lat).toFixed(6) : ''
          this.subjectAdd.lng = res.data.lng ? parseFloat(res.data.lng).toFixed(6) : ''
        }
      }).catch(err => {})
    },
    areaRecursion(currentAreaId, areaArr, areaData, beginIndex, endIndex) {
      if(!areaData.children) return
      areaData.children.forEach(item => {
        if(currentAreaId.slice(beginIndex, endIndex) === item.areaId.slice(beginIndex, endIndex)) {
          if(currentAreaId.length >= 8) { //街道
            if(endIndex >= 10) {
              return
            }  else {
              areaArr.push(item.areaId)
              areaData = item
              beginIndex += 2
              endIndex += 2
              this.areaRecursion(currentAreaId, areaArr, areaData, beginIndex, endIndex)
            }
          } else {
            if(currentAreaId.slice(2,6) == '0000'){ // 省或直辖市
              if(endIndex >= 4) {
                return
              }  else {
                areaArr.push(item.areaId)
                areaData = item
                beginIndex += 2
                endIndex += 2
                this.areaRecursion(currentAreaId, areaArr, areaData, beginIndex, endIndex)
              }
            } else if(currentAreaId.slice(2,4) !== '00' && currentAreaId.slice(4,6) == '00') { // 市
              if(endIndex >= 6) {
                return
              } else {
                areaArr.push(item.areaId)
                areaData = item
                beginIndex += 2
                endIndex += 2
                this.areaRecursion(currentAreaId, areaArr, areaData, beginIndex, endIndex)
              }
            } else { 
              if(endIndex >= 8) { // 区
                return
              } else {
                if(currentAreaId.slice(0,4) === '6590') {
                  // 新疆区域, 石河子市, 阿拉尔市, 图木舒克市, 五家渠市的区域编码规则与其他地区不同, 新僵地区区域编码特殊处理
                  endIndex += 4
                } else {
                  endIndex += 2
                }
                areaArr.push(item.areaId)
                areaData = item
                beginIndex += 2
                this.areaRecursion(currentAreaId, areaArr, areaData, beginIndex, endIndex)
              }
            }
          }
        }
      })
    },
    areaNameEcho() {
      let currentAreaId = this.subjectAdd.areaId
      let areaArr = []
      this.areaRecursion(this.subjectAdd.areaId, areaArr, this.areaData, 0, 2)

      // 直辖市下属区, 区域数组只有2个元素
      if(currentAreaId.slice(0,2) === '11' || currentAreaId.slice(0,2) === '12' || currentAreaId.slice(0,2) === '31' || currentAreaId.slice(0,2) === '50') {
        if(currentAreaId.slice(2,6) !== '0000' && currentAreaId.slice(2,6) !== '0101') { // 非省 且 非第一个区
          areaArr = [areaArr[0], areaArr[2]]
        }
      }
      this.subjectAdd.areaId = areaArr
    },
    async getModule(){
      let result =  await  moduleApi.getFunctionList()
      this.functionModule = result.data
    }
  },
  mounted() {
    if(this.$route.query.type === 'add') {
      this.addInit()
    } else {
      this.editInit(this.$route.query.id)
    }
    this.getModule()
  },
  created() {
    let that = this;
    that.areaList.props.lazyLoad = function (node, resolve) {
      let code = node.value ? node.value : that.parentId;
      if (code.length > 6) { 
        return resolve([]) 
      }
      subManageApi.tobAreaTree({parentId: code}).then(r => {
        if (r.code === 200) {
          that.areaData = r.data
          resolve(r.data.children)
        }
      });
    }
  },
  watch: {
    areaData: {
      handler(newVal) {
        this.areaNameEcho()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
  .tittle {
    text-align: left;
    font-size: 18px;
    font-weight: 500;
  }
  .content {
    text-align: left;
    .el-form {
      padding: 0 calc((100% - 1200px) / 2);
    }
    .item {
      margin-top: 40px;
    }
  }
  .footer {
    text-align: right;
  }
  .item {
    text-align: left;
  }
  #container {
    margin-bottom: 20px;
    width: 960px;
    height: 600px;
  }
  .form-item {
    display: -webkit-flex; /* Safari */
    display: flex;
    flex-wrap: wrap;
  }
  .dialogDiv::v-deep .el-dialog {
    width: 1000px;
  }
  .tooltip {
    font-size: 20px;
    position: absolute;
    top: -32px;
    right: -30px;
  }
  .metre{
    margin-right: 10px;
  }
  .manage-info-flex{
    display: flex;
  }
  .w750{
    width: 450px !important;
  }

</style>